const advancedComparisonTable = (editor) => {

    editor.BlockManager.add('advancedComparisonTable', {
        category: 'Built In Components',
        label: 'Comparison Grid',
        attributes: {},
        content: `
          <div class="text-center">
            <h4 class="mb-4"><strong>Pricing</strong></h4>
            <div class="btn-group mb-4" role="group" aria-label="Basic example">
              <button type="button" class="btn btn-dark active">Monthly billing</button>
            </div>
          </div>
          <div class="row m-4">
            <div class="col-md-3">
              <div class="card">
                <div class="mx-2 card-body">
                  <h5 class="card-title my-2 ">Hobby</h5>
                  <p class="text-muted mb-2">
                    All the essentials for starting a business
                  </p>
                  <p class="h2 fw-bold">$12<small class="text-muted">/mo</small></p>
                  <a href="#" class="btn btn-dark d-block mb-2 mt-3 text-capitalize">Buy Hobby</a>
                </div>
                <div class="card-footer">
                  <p class="text-uppercase fw-bold" >What's included</p>
                  <ol class="list-unstyled mb-0 px-4">
                    <p class="my-3 fw-bold text-muted text-center">
                    </p>
                    <li class="mb-3">
                      <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                    </li>
                    <li class="mb-3">
                      <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card">
                <div class="mx-2 card-body">
                  <h5 class="card-title my-2 ">Freelancer</h5>
                  <p class="text-muted">
                    All the essentials for starting a business
                  </p>
                  <p class="h2 fw-bold">$20<small class="text-muted" >/mo</small></p>
                  <a href="#" class="btn btn-dark d-block mb-2 mt-3 text-capitalize">Buy Freelancer</a>
                </div>
                <div class="card-footer">
                  <p class="text-uppercase fw-bold" >What's included</p>
                  <ol class="list-unstyled mb-0 px-4">
                    <p class="my-3 fw-bold text-muted text-center">
                    </p>
                    <li class="mb-3">
                      <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                    </li>
                    <li class="mb-3">
                      <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                    </li>
                    <li class="mb-3">
                      <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card">
                <div class="mx-2 card-body">
                  <h5 class="card-title my-2 ">Startup</h5>
                  <p class="text-muted">
                    All the essentials for starting a business
                  </p>
                  <p class="h2 fw-bold">$40<small class="text-muted" >/mo</small></p>
                  <a href="#" class="btn btn-dark d-block mb-2 mt-3 text-capitalize">Buy Startup</a>
                </div>
                <div class="card-footer">
                  <p class="text-uppercase fw-bold" >What's included</p>
                  <ol class="list-unstyled mb-0 px-4">
                    <p class="my-3 fw-bold text-muted text-center">
                    </p>
                    <li class="mb-3">
                      <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                    </li>
                    <li class="mb-3">
                      <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                    </li>
                    <li class="mb-3">
                      <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                    </li>
                    <li class="mb-3">
                      <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card">
                <div class="mx-2 card-body">
                  <h5 class="card-title my-2 ">Enterprise</h5>
                  <p class="text-muted">
                    All the essentials for starting a business
                  </p>
                  <p class="h2 fw-bold">$55<small class="text-muted">/mo</small></p>
                  <a href="#" class="btn btn-dark d-block mb-2 mt-3 text-capitalize">Buy Enterprise</a>
                </div>
                <div class="card-footer">
                  <p class="text-uppercase fw-bold" >What's included</p>
                  <ol class="list-unstyled mb-0 px-4">
                    <li class="mb-3">
                      <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                    </li>
                    <li class="mb-3">
                      <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                    </li>
                    <li class="mb-3">
                      <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                    </li>
                    <li class="mb-3">
                      <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                    </li>
                    <li class="mb-3">
                      <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                    </li>
                    <li class="mb-3">
                      <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                    </li>
                    <li class="mb-3">
                      <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        `
    })
};

export default advancedComparisonTable;